const Simple = `AAAAAABBBBBBBBBCCCCCCCCDDDDDDDEEEEE`;

export default Simple;
